module.exports = __webpack_public_path__ + "img/wechat_lss.cbff5b33.png";